export const removeHashtagWords = (inputString: string) => {
  return inputString?.replace(/\s*#\S+/g, '');
};
